// extracted by mini-css-extract-plugin
export var configurationSection = "_z0-0";